<script setup lang="ts">
import type { Values } from '@/composables/useValues'

const props = defineProps<{
    dimension?: Dimension
    data?: Values<Import>
    onlyTopFive?: boolean
}>()

/**
 * Translations.
 */
const { t } = useI18n()

/**
 * Use query params.
 */
const { config, options } = useParams()

/**
 * Use framework.
 */
const { isImportingRisk } = useFramework()

/**
 * Get the total value for a product.
 */
function getTotalByProduct(id: number) {
    return props.data?.countryData?.products
        ?.filter(product => product.product_id === id)
        ?.reduce((total, { import_value }) => total + import_value, 0)
}

/**
 * Top 5 at risk products.
 */
const topFive = computed(() => {
    return options.importProducts
        .sort((a, b) => {
            const aTotal = getTotalByProduct(a.value) || 0
            const bTotal = getTotalByProduct(b.value) || 0

            return bTotal - aTotal
        })
        .slice(0, 5)
})

/**
 * Show or hide the button.
 */
const show = computed(() => {
    return isImportingRisk(props.dimension)
})
</script>

<template>
    <UiSelect
        v-if="show"
        v-model="config.importProducts"
        :label="t('filter-by-product')"
        direction="top"
        autocomplete
        selectable
        multiple
        class="flex-shrink-0"
        data-tutorial-step="3"
        :data-tutorial-text="t('tutorial-filter-products')"
        data-tutorial-attach-top="top"
        :options="onlyTopFive ? topFive : options.importProducts"
    />
</template>